module.exports = __webpack_public_path__ + "static/deskcom-b38b4da8b3e7cb7fbf11866c349de398.png";